(ns basic-components.breadcrumbs
  (:require [frontend.routing :as routing]
            [frontend.utils :as fu]))


(defn active-item [label class-name]
  [:li
   {:class-name (fu/cs (when class-name
                         class-name)
                       "zap-breadcrumbs--active")}
   [:span label]])

(defn normal-item [label class-name on-click!]
  [:li
   {:class-name (fu/cs (when class-name
                         class-name)

                       "zap-breadcrumbs__item")}
   [:a.zap-breadcrumbs__link
    {:href     "#"                                          ;(routing/path-for path)
     :on-click (fn [e]
                 (.preventDefault e)
                 (.stopPropagation e)
                 (when (fn? on-click!)
                   (on-click!))
                 false)}
    label]
   [:span.zap-breadcrumbs__divider
    [:i.fal.fa-chevron-right]]])

(defn view [breadcrumbs class-name]
  (fn [breadcrumbs class-name]
    [:ul.zap-breadcrumbs.my-2
     (->> breadcrumbs
          (map-indexed
            (fn [idx {:keys [label active? on-click!]}]
              (let [uid (str "breadcrumb-" idx "-" label "-" active?)]
                (if active?
                  ^{:key uid}
                  [active-item label class-name]
                  ^{:key uid}
                  [normal-item label class-name on-click!]))))
          (doall))]))
